import { replaceWildcards } from '../../lib/helper/helper'

type Props = {
  highlights: Highlight[]
  wildcards: { [key: string]: string }
}

export function Highlights({ highlights, wildcards }: Props) {
  return (
    <div className="max-w-full overflow-hidden my-16 xs:my-12 xs:my-16">
      <div className="flex flex-wrap justify-around gap-12">
        {highlights.map(({ title, subtitle, fa_icon }: Highlight, index) => {
          let style, icon, color
          if (fa_icon.split(' ').length < 2) {
            style = 'fa-duotone'
            icon = 'fa-face-smile'
            color = '#26a5ef'
          } else {
            style = fa_icon.split(' ')[0]
            icon = fa_icon.split(' ')[1]
            color = fa_icon.split(' ')[2]
          }
          return (
            <div
              key={index}
              className="flex flex-col items-center"
              style={{ minWidth: '250px', maxWidth: '300px' }}
            >
              {style && icon && (
                <span
                  className={style + ' ' + icon + ' text-4xl mb-4'}
                  style={{ color }}
                />
              )}
              <div
                className="text-center font-semibold mb-2 uppercase"
                style={{ fontSize: '1.1rem' }}
              >
                {replaceWildcards(title, wildcards)}
              </div>
              <div className="text-sm text-center">
                {replaceWildcards(subtitle, wildcards)}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
